import React from 'react'
import { Button, Col, Spinner } from 'react-bootstrap'

type Props = {
  isLoading: boolean
}
const AddButtonGroup = ({ isLoading }: Props) => {
  return (
    <>
      <Col lg={5} className="mx-auto" data-testid="add-button-group">
        <Button
          variant="primary"
          type="submit"
          className="mt-5 ml-5"
          disabled={isLoading}
        >
          {isLoading && (
            <span className="mr-2">
              <Spinner
                animation="border"
                size="sm"
                className="text-white"
                data-testid="add-spinner"
              />
            </span>
          )}
          Submit
        </Button>
      </Col>
    </>
  )
}

export default AddButtonGroup
